import React from "react";

// Houston Title Co. brand wordmark (recolored for dark backgrounds).
// `size` sets the rendered height in pixels; width scales automatically.
export const Monogram = ({ size = 40, className = "" }) => {
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/htc-logo.png`}
      alt="Houston Title Co."
      style={{ height: size, width: "auto" }}
      className={`block select-none ${className}`}
      draggable={false}
      data-testid="brand-logo"
    />
  );
};
